import Vue from "vue";
import "./plugins/axios";
import "./registerServiceWorker";

Vue.config.productionTip = false;
const showDevTools = process.env.VUE_APP_SHOW_DEV_TOOLS;

if (showDevTools == "true" || showDevTools == true) {
  Vue.config.devtools = true;
} else {
  Vue.config.devtools = false;
}

import Notifications from "vue-notification";
Vue.use(Notifications);

import adminMain from "./main-admin.js";
import interviewMain from "./main-interview.js";



let adminConfiguration = adminMain;
let interviewConfiguration = interviewMain;
const isInterviewApp = process.env.VUE_APP_BASE_IS_INTERVIEW_APP;
if (isInterviewApp == "true" || isInterviewApp == true) {
  var interviewApp = interviewConfiguration.$mount("#app");
} else {
  var panelApp = adminConfiguration.$mount("#app");
}
